export const EWOTS_DISMISSAL = 'EWOTS_DISMISSAL';
